import { k } from "../kaplay";

export function life({ maxLife }){
  return {
    id: "life",
    life: maxLife,
    maxLife: maxLife,

    async takeDamage(damage){
      k.play("hit")
      this.life -= damage;
      this.use(k.color(200, 0, 0));
      this.unuse("move");
      
      await k.wait(0.5);
      this.color = new k.Color(255, 255, 255);
      this.use(k.move(k.center().angle(new k.Vec2(this.pos.x, this.pos.y)), this.speed));
      
      if (this.life <= 0){
        k.play("death");
        this.destroy();
      }
    }
  }
}